export default "__VITE_ASSET__vdBo6Xya__"